import React from 'react';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import { images } from '../assets/images';
import { fonts, scale } from '../Styles';

type Props = {
  /** header title of the header */
  headerTitle: string;
  /** if burger icon is hidden or not */
  burgerHidden?: boolean;
  /** invoked if the burger icon is clicked */
  userPressedBurgerMenu: () => void;
};

/** Header title component specific to MNOHS (created since the switch to expo web) */
export const MNOHSHeader: React.FC<Props> = ({ headerTitle, burgerHidden, userPressedBurgerMenu }) => {
  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        {/* header title */}
        <Text style={styles.title}>{headerTitle}</Text>
      </View>
      {!burgerHidden && (
        <TouchableOpacity style={styles.menuButton} onPress={userPressedBurgerMenu}>
          <Image source={images.hamburgerMenu} style={styles.menuImage} />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: scale(20),
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuButton: {
    position: 'absolute',
    left: scale(20),
    height: scale(21),
    width: scale(29),
  },
  menuImage: {
    aspectRatio: 1,
    height: '100%',
  },
  title: {
    ...fonts.header1,
    fontWeight: '700',
  },
});
